import {
  Box,
  Button,
  FormControl,
  FormGroup,
  Grid,
  Input,
  InputLabel,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { ROUTE_PATH } from "../../helper/Constants";
import "./Cart.css";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { displayNo } from "../../helper/Number";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeFromCart } from "../../redux/slices/cartSlice";
import { addAddress } from "../../redux/slices/addressSlice";
import { getLocalStorage } from "../../helper/Storage";

const Cart = () => {
  const [t] = useTranslation();
  const lan = getLocalStorage("userLanguage");

  const myOrder = useSelector((state) => state.cart.cart);
  const userAddress = useSelector((state) => state.address.address);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const contacts = useSelector((state) => state.contacts.contacts);
  const incenses = useSelector((state) => state.incenses.items);
  const spices = useSelector((state) => state.spices.items);

  const [fullName, setFullName] = useState(userAddress?.fullName);
  const [phoneNumber, setPhoneNumber] = useState(userAddress?.phone);
  const [address, setAddress] = useState(userAddress?.address);

  const handleSubmit = () => {
    dispatch(
      addAddress({
        address: {
          fullName: fullName,
          phone: phoneNumber,
          address: address,
        },
      }),
    );
    navigate("/" + ROUTE_PATH.CHECKOUT);
  };

  const increaseQuantity = (id, type) => {
    dispatch(
      addToCart(
        { itemId: id, type, deliveryFee: contacts.deliveryFee },
        "addToCart",
      ),
    );
  };

  const decreaseQuantity = (id, type) => {
    dispatch(
      removeFromCart(
        { itemId: id, type, deliveryFee: contacts.deliveryFee },
        "removeFromCart",
      ),
    );
  };

  return (
    <Box sx={{ padding: "15px", textAlign: "left" }}>
      <Typography
        variant="h4"
        sx={{
          borderBottom: 1,
          textAlign: "center",
          padding: "10px 0",
          borderColor: "#abababcc",
        }}
      >
        {t("cart.header")}
      </Typography>
      {myOrder?.items?.length > 0 &&
      incenses?.length > 0 &&
      spices?.length > 0 ? (
        <Box>
          <Grid container sx={{ alignItems: "center" }}>
            <Typography
              variant="h5"
              sx={{ padding: "10px 20px 10px 0", fontWeight: "bold" }}
            >
              {t("cart.total")}: ₹{" "}
              {displayNo(
                (
                  myOrder.items.reduce(
                    (a, v) => (a = a + v.offerPrice * v.count),
                    0,
                  ) + myOrder.deliveryFee
                ).toFixed(2),
              )}
            </Typography>
            <Typography variant="span" sx={{ padding: "10px 20px 10px 0" }}>
              {t("cart.delivery-fee")}: ₹{" "}
              {displayNo(myOrder?.deliveryFee?.toFixed(2))}
            </Typography>
            <Typography variant="span" sx={{ padding: "10px 20px 10px 0" }}>
              {t("cart.item-total")}: ₹{" "}
              {displayNo(
                myOrder.items
                  .reduce((a, v) => (a = a + v.offerPrice * v.count), 0)
                  .toFixed(2),
              )}
            </Typography>
          </Grid>
          <Box sx={{ padding: "10px" }}>
            <Grid container>
              <Grid
                size={{ md: 4, xs: 12 }}
                sx={{ padding: "10px 20px", border: "1px solid #80787869" }}
              >
                <FormGroup>
                  <FormControl sx={{ display: "block", paddingBottom: "15px" }}>
                    <InputLabel htmlFor="name">
                      {t("b2b.fullname")} *
                    </InputLabel>
                    <Input
                      required
                      id="name"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      sx={{ width: "100%" }}
                    />
                  </FormControl>
                  <FormControl sx={{ display: "block", paddingBottom: "15px" }}>
                    <InputLabel htmlFor="phone">{t("b2b.phone")} *</InputLabel>
                    <Input
                      required
                      id="phone"
                      type="tel"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      sx={{ width: "100%" }}
                    />
                  </FormControl>
                  <FormControl sx={{ display: "block", paddingBottom: "15px" }}>
                    <InputLabel htmlFor="address">
                      {t("b2b.address")} *
                    </InputLabel>
                    <Input
                      required
                      id="address"
                      value={address}
                      sx={{ width: "100%" }}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </FormControl>
                  <Button
                    disabled={!fullName || !phoneNumber || !address}
                    variant="contained"
                    onClick={handleSubmit}
                  >
                    {t("cart.checkout")}
                  </Button>
                </FormGroup>
              </Grid>
              <Grid
                size={{ md: 8, xs: 12 }}
                sx={{ padding: "10px 20px", border: "1px solid #80787869" }}
              >
                {[...myOrder.items]
                  ?.sort((a, b) => a.order - b.order)
                  .map((item, index) => {
                    let product =
                      item.type === ROUTE_PATH.INCENSES
                        ? incenses.filter(
                            (incense) => incense.id === item.id,
                          )[0]
                        : spices.filter((spice) => spice.id === item.id)[0];

                    return (
                      <Grid container key={"cart_item_" + index}>
                        <Grid
                          size={{ md: 12, xs: 12 }}
                          container
                          sx={{
                            padding: "2px",
                            borderBottom: 1,
                            borderColor: "#9494943d",
                            marginBottom: "10px",
                          }}
                        >
                          <Grid
                            size={{ md: 2, xs: 4 }}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignSelf: "center",
                            }}
                          >
                            <Link
                              to={
                                "/" +
                                ROUTE_PATH.PRODUCT_DETAILS +
                                product.id +
                                "/" +
                                item.type
                              }
                              style={{ textAlign: "center" }}
                            >
                              <img
                                src={
                                  process.env.REACT_APP_API_URL +
                                  product.thumbnail
                                }
                                alt={product.thumbnail}
                                className="cart-img"
                              ></img>
                            </Link>
                          </Grid>
                          <Grid size={{ md: 10, xs: 8 }} container>
                            <Grid
                              size={{ lg: 6 }}
                              sx={{ padding: "5px", alignSelf: "center" }}
                            >
                              {product.name.find((n) => n.key === lan).value}
                            </Grid>
                            <Grid
                              size={{ lg: 4 }}
                              sx={{ padding: "5px", alignSelf: "center" }}
                            >
                              <Typography
                                variant="caption"
                                sx={{
                                  fontWeight: "bold",
                                  padding: "0 3px",
                                  fontSize: "15px",
                                }}
                              >
                                ₹
                                {displayNo(
                                  Number(
                                    product.price.offerPrice * item.count,
                                  ).toFixed(2),
                                )}
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{
                                  textDecoration: "line-through",
                                  color: "#888888ff",
                                }}
                              >
                                ₹
                                {displayNo(
                                  Number(
                                    product.price.actualPrice * item.count,
                                  ).toFixed(2),
                                )}
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{
                                  fontWeight: "bold",
                                  padding: "0 3px",
                                  color: "#28d311ff",
                                }}
                              >
                                {displayNo(product.price.offer)}
                                {t("off")}
                              </Typography>
                            </Grid>
                            <Grid
                              size={{ lg: 2 }}
                              sx={{
                                padding: "5px",
                                alignSelf: "center",
                                display: "flex",
                                justifySelf: "center",
                                alignItems: "center",
                              }}
                            >
                              <Button
                                sx={{
                                  border: 1,
                                  padding: "5px",
                                  minWidth: "35px",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  decreaseQuantity(product.id, item.type)
                                }
                              >
                                -
                              </Button>
                              <Typography
                                sx={{ textAlign: "center", minWidth: "35px" }}
                              >
                                {displayNo(item.count.toString())}
                              </Typography>
                              <Button
                                sx={{
                                  border: 1,
                                  padding: "5px",
                                  minWidth: "35px",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  increaseQuantity(product.id, item.type)
                                }
                              >
                                +
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    );
                  })}
              </Grid>
            </Grid>
          </Box>
        </Box>
      ) : (
        <Box sx={{ minHeight: "200px", display: "flex" }}>
          <Box sx={{ margin: "auto" }}>{t("cart.no-item-found")}</Box>
        </Box>
      )}
    </Box>
  );
};

export default Cart;
